// ============================================================================
//  DESIGN TOKENS: the one place to change the dashboard's colors.
//
//  Used by tailwind.config.js (every bg-*/text-*/border-* class), by the CSS
//  variables in src/index.css, and by the charts
//  (import { chartColors } from "../theme/palette").
//
//  - brand:   the accent color (indigo). Existing blue/indigo/sky/orange classes
//             in the code are mapped to this, so changing it re-colors buttons,
//             links, focus rings and highlights across the whole app.
//  - neutral: the grey scale. gray/slate/zinc/neutral/stone classes all map here.
//  - semantic: page background, card surface, text and border colors.
//
//  Keep this file CommonJS (module.exports): tailwind.config.js requires it.
// ============================================================================

const brand = {
  50: "#eef2ff",
  100: "#e0e7ff",
  200: "#c7d2fe",
  300: "#a5b4fc",
  400: "#818cf8",
  500: "#6366f1",
  600: "#4f46e5", // primary buttons, links, active states
  700: "#4338ca",
  800: "#3730a3",
  900: "#312e81",
  950: "#1e1b4b",
};

const neutral = {
  50: "#f8f9fb", // page background
  100: "#f3f4f6", // sidebar, table header, alternate rows
  200: "#e5e7eb", // borders
  300: "#d1d5db",
  400: "#a3a3a3",
  500: "#737373", // secondary text
  600: "#525252",
  700: "#404040",
  800: "#262626",
  900: "#171717", // primary text
  950: "#0a0a0a",
};

const ink = neutral[900];
const paper = "#ffffff";

const semantic = {
  canvas: neutral[50], // main background
  surface: paper, // cards
  line: neutral[200], // borders
  fg: neutral[900], // primary text
  muted: neutral[500], // secondary text
};

// subtle status colors
const status = {
  success: "#15803d",
  warning: "#b45309",
  danger: "#b91c1c",
  info: brand[600],
};

// colors for charts, in the order series should use them
const chartColors = {
  primary: brand[600],
  primaryDark: brand[700],
  secondary: neutral[800],
  grid: neutral[200],
  axis: neutral[500],
  gridDark: neutral[700],
  axisDark: neutral[400],
  tooltipBorder: neutral[200],
  warning: "#f59e0b",
  danger: "#dc2626",
  series: [brand[600], neutral[800], brand[300], neutral[500], brand[800], neutral[300], "#16a34a", "#dc2626"],
  // one color per compared entity (stations), assigned in this order and never cycled;
  // validated for color-blind separation (several are under 3:1 on white, so charts
  // using them also offer a table view)
  categorical: ["#2a78d6", "#eb6834", "#1baf7a", "#eda100", "#e87ba4", "#008300", "#6250d6", "#e34948"],
};

module.exports = { brand, neutral, ink, paper, semantic, status, chartColors };
